import React from "react";
import { Box } from "@mui/material";

interface MyTaxApplicationPrintCardInfoItemProps {
  label: string;
  value: string;
}

const MyTaxApplicationPrintCardInfoItem: React.FC<
  MyTaxApplicationPrintCardInfoItemProps
> = ({ label, value }) => {
  return (
    <>
      <Box display="flex">
        {label}
        <Box marginLeft="10px">{value}</Box>
      </Box>
    </>
  );
};

export default MyTaxApplicationPrintCardInfoItem;
